import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Selling from "../../../containers/modules/sales/selling";
import ViewSelling from "./selling/view";

export default function SalesInvoiceRoute(props) {
  const { authUser } = props;
  return (
    <Route path="sales-invoice">
      <Route
        index
        element={
          <AccessControl
            name={"Selling List"}
            auth={authUser}
            component={() => <Selling authUser={authUser} />}
          />
        }
      />
      <Route
        path="view/:id"
        element={
        <AccessControl
            name={"Selling Show"}
            auth={authUser}
            component={() => <ViewSelling />}
        />
        }
    />
    </Route>
  );
}
